import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import DwDashboardRoutes from "./browserrouter";
import AppErrorBoundary from "./AppErrorBoundary";
import { WalletProvider } from "./walletprovider/WalletProvider";
import "./i18n";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "./assets/scss/style.scss";
import AppContextProvider from "./AppContextProvider";
import { DwMpcWalletBackendProvider } from "./mpcwalletprovider/DwMpcWalletBackendProvider";
import { AvatarProvider } from "./provider/AvatarProvider";
import { ChatSecurityProvider } from "./provider/ChatSecurityProvider";
import { initUploadWorker, } from "./utils/uploadworker/uploadworkerutil";
initUploadWorker();
async function registerZipDownloadServiceWorker() {
    console.log("registering zipDownloadServiceWorker");
    if (!navigator.serviceWorker) {
        return;
    }
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (let registration of registrations) {
        if (registration.active?.scriptURL?.includes('zipDownloadServiceWorker')) {
            await registration.unregister();
        }
    }
    await navigator.serviceWorker.register("/zipDownloadServiceWorker.js?v=2.2", { scope: "/download-zip" });
    await navigator.serviceWorker.ready;
    /*DOESN'T WORK TO KEEP ALIVE
    setInterval(() => {
      console.log("keepalive interval passed");
      if (navigator.serviceWorker.controller) {
        console.log("keepalive: we have a controller");
        navigator.serviceWorker.controller.postMessage({ keepAlive: true });
        console.log("keepalive: message posted");
      }
      console.log("keepalive: exiting");
    }, 240000);*/
    /* DOESN'T WORK TO KEEP ALIVE
    const channel = new BroadcastChannel("keep-alive");
    setInterval(() => channel.postMessage("ping"), 240000);*/
    /* DOES N'T WORK TO KEEP ALIVE
    navigator.serviceWorker.ready.then((registration: any) => {
      return registration.sync.register("keep-alive");
    });*/
}
async function unregisterZipDownloadServiceWorker() {
    console.log("unregisterZipDownloadServiceWorker");
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations.forEach((registration) => {
                const scriptUrl = registration.active?.scriptURL ||
                    registration.waiting?.scriptURL ||
                    registration.installing?.scriptURL ||
                    "";
                if (scriptUrl.includes("zipDownloadServiceWorker")) {
                    registration.unregister();
                }
            });
        });
    }
}
const forceRegister = false;
if (!window.showDirectoryPicker || forceRegister) {
    registerZipDownloadServiceWorker();
}
else {
    unregisterZipDownloadServiceWorker();
}
const root = ReactDOM.createRoot(document.getElementById("root"));
class BootstrapReady extends React.Component {
    componentDidMount() {
        window.__markAppMounted?.();
    }
    render() {
        return this.props.children;
    }
}
root.render(_jsx(AppErrorBoundary, { children: _jsx(BootstrapReady, { children: _jsx(AppContextProvider, { children: _jsx(WalletProvider, { children: _jsx(ChatSecurityProvider, { children: _jsx(DwMpcWalletBackendProvider, { children: _jsx(AvatarProvider, { children: _jsx(DwDashboardRoutes, {}) }) }) }) }) }) }) }));
